import i18n from "i18next";
import { z } from "zod";

const dateFieldSchema = z.preprocess((value) => {
  if (value === "" || value === null || value === undefined) return undefined;

  if (typeof value === "string" || typeof value === "number" || value instanceof Date) {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? value : parsed;
  }

  return value;
}, z.date().nullable().optional());

interface UpdatePortServiceTimesSchemaOptions {
  skipEtsPastValidation?: boolean;
}

export const createUpdatePortServiceTimesSchema = (
  options: UpdatePortServiceTimesSchemaOptions = {},
) =>
  z
    .object({
      ets: dateFieldSchema,
      etc: dateFieldSchema,
    })
    .superRefine((val, ctx) => {
      const now = new Date();

      if (!options.skipEtsPastValidation && val.ets && val.ets < now) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ets"],
          message: i18n.t("form-validation.must-not-be-in-past", { label: "ETS" }),
        });
      }

      if (val.etc && val.etc < now) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["etc"],
          message: i18n.t("form-validation.must-not-be-in-past", { label: "ETC" }),
        });
      }

      if (val.ets && val.etc && val.ets >= val.etc) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["etc"],
          message: i18n.t("form-validation.must-be-after", { subject: "ETC", object: "ETS" }),
        });
      }
    });

export const updatePortServiceTimesSchema = createUpdatePortServiceTimesSchema();
